import { format } from 'date-fns';

/** What the history tables need to show a visit's Zamknięto. */
interface ClosableVisit {
  closedAt?: string | Date | null;
  endTime?: string | Date | null;
}

/** Rendered when a visit has no usable closure at all. */
const NO_CLOSURE = '-';

/**
 * When the visit was closed — completed, cancelled or aborted.
 *
 * Falls back to the booked end time, exactly as the history queries do when
 * they order rows: the backfill migration is run by hand per environment, so
 * until it has, `closedAt` is null on every historic visit. Reading the same
 * fallback here keeps the column and the row order in agreement.
 */
export const resolveVisitClosure = (visit: ClosableVisit): Date | null => {
  const raw = visit.closedAt ?? visit.endTime ?? null;
  if (!raw) {
    return null;
  }

  const closure = raw instanceof Date ? raw : new Date(raw);
  return Number.isNaN(closure.getTime()) ? null : closure;
};

/** The Zamknięto cell: date and time, because same-day closures must differ. */
export const formatVisitClosure = (visit: ClosableVisit): string => {
  const closure = resolveVisitClosure(visit);
  return closure ? format(closure, 'dd/MM/yyyy HH:mm') : NO_CLOSURE;
};
